import request from "~/utils/http";

const authApi = {
	token : async (username, password) => {
		const url = 'auth/login';
		return await request.post(url, {username, password});
	},
	register : async (params) => {
		const url = 'auth/register';
		return await request.post(url, params);
	},
	// Cấu hình nút Google (public): {enabled, client_id} — enabled=false thì ẩn nút
	googleClient : async () => {
		const url = 'auth/google/client';
		return await request.get(url);
	},
	// Đăng nhập/đăng ký bằng Google: credential = ID token từ Google Identity Services
	googleLogin : async (credential) => {
		const url = 'auth/google';
		return await request.post(url, {credential});
	},
	current : async () => {
		const url = 'auth/current';
		return await request.get(url);
	},
	refresh : async (params) => {
		const url = 'auth/refresh';
		return await request.post(url, params);
	},
	update : async (params) => {
		const url = 'auth/update';
		return await request.post(url, params);
	},
	password : async (params) => {
		const url = 'auth/password';
		return await request.post(url, params);
	},
	// Xác minh email từ link trong mail (public — không cần đăng nhập)
	verifyEmail : async (uid, token) => {
		const url = 'auth/email-verify';
		return await request.post(url, {uid, token});
	},
	// Gửi lại email xác minh cho chính user đang đăng nhập (cooldown 2 phút)
	resendVerifyEmail : async () => {
		const url = 'auth/email-verify/resend';
		return await request.post(url);
	},
	// Danh sách tài khoản có thể đăng nhập vào (impersonation)
	loginAsCandidates : async (keyword = '') => {
		const url = keyword ? `auth/login-as/candidates?keyword=${encodeURIComponent(keyword)}` : 'auth/login-as/candidates';
		return await request.get(url);
	},
	// Phát hành token cho tài khoản đích → dùng làm loginAsToken
	loginAs : async (userId) => {
		const url = 'auth/login-as';
		return await request.post(url, {user_id: userId});
	},
};

export default authApi;